import { useMemo } from "react";
import { Column } from "react-table";
import { Title } from "@funcional/react-ui";
import { useI18n } from "@common/helpers";
import {
    DefaultColumnFilter,
  GridView,
} from "@funcional/react-table-ui";
import { useFinancialReimbursement } from "../hooks/useFinancialReimbursement";
import { IFinancialReimbursement } from "../contracts"
import { useHistory } from "react-router-dom";

export default function ListTransactions() {
  const { intlEnum } = useI18n();
  const history = useHistory();
  const showRecord = (row: any) => history.push(`/refund/financial-reimbursement/read/${row?.original?.industry?.name}`);
  const editRecord = (row: any) => history.push(`/refund/financial-reimbursement/edit/${row?.original?.industry?.name}`);

  const columns: Column<IFinancialReimbursement>[] = useMemo(
    () => [
        {
          Header: "Indústria",
          accessor: "industryId",
          Filter: DefaultColumnFilter,
          Cell: ({value, row}) => <>{row?.original?.industry?.name}</>
        },
        {
          Header: "Tipo Credor",
          accessor: "type",
          Cell: ({value}) => {
            if (value === "RETAIL_CHAIN") return <>Bandeira</>
            if (value === "DISTRIBUTOR_CHAIN") return <>Distribuidor</>
          }
        },
        { 
          Header: "Fechamento", 
          accessor: "closureType" ,
          Cell: ({value}) => {
            if (value === "MONTHLY") return <>Mensal</>
            if (value === "FORTWEEKLY") return <>Quinzenal</>
          }
        },
        { 
          Header: "Dia de fechamento padrão", 
          accessor: "closingDay",
          Cell: ({value}) => <>{value ? value : '-'}</>
        },
        { 
          Header: "Excessões", 
          accessor: "exceptions",
          Cell: ({value}) => {
            if (value instanceof Array && value.length > 0) {
              return <>{`${value.length} ${value.length === 1 ? 'exceção' : 'exceções'}`}</>
            } else {
              return <>0 exceções</>
            }
          }
        }
    ],
    [intlEnum]
  );

  return (
    <>
      <div className="flex items-center w-full mb-4">
        <div className="flex-1">
          <Title marginBottom={0}>Configuração Ressarcimento Financeiro</Title>
        </div>
      </div>
      <hr className="mb-2" />

      <GridView<IFinancialReimbursement>
        paginationType="cursor"
        accessControlResourceName="financialReimbursement"
        columns={columns}
        showRecord={showRecord}
        editRecord={editRecord}
        hook={useFinancialReimbursement}
      />
    </>
  );
}
